import {
  logFeatureEvent,
  reportFeatureIssue,
  type ObservabilityScope,
} from "./shared";

type ApiKeyScope = "account" | "property";
type ApiAccessAction = "create_key" | "revoke_key" | "verify_connection" | "load_keys";

export const logApiAccessEvent = (
  event: "key_created" | "key_revoked" | "connection_verified",
  scope: ObservabilityScope,
  keyScope: ApiKeyScope,
) =>
  logFeatureEvent({
    feature: "api_access",
    event,
    scope,
    attributes: { key_scope: keyScope },
  });

/**
 * `ApiAccessForbiddenError` is the plan gate, and a failed verify usually means
 * the property has no data yet — both expected, so they stay out of Issues.
 */
export const logApiAccessBlocked = (
  event: "plan_gate_hit" | "verification_failed",
  scope: ObservabilityScope,
  attributes?: { keyScope?: ApiKeyScope; reason?: string },
) =>
  logFeatureEvent({
    feature: "api_access",
    event,
    level: "warn",
    scope,
    attributes: {
      key_scope: attributes?.keyScope ?? null,
      reason: attributes?.reason ?? null,
    },
  });

export const reportApiAccessFailure = (
  action: ApiAccessAction,
  error: unknown,
  scope: ObservabilityScope,
  keyScope?: ApiKeyScope,
) =>
  reportFeatureIssue({
    feature: "api_access",
    error,
    action,
    message: `API access: ${action} failed`,
    scope,
    context: { key_scope: keyScope ?? null },
  });
